import React, { useState } from "react";
import { arrayOf, func, shape, string } from "prop-types";
import uuid from "uuid";

import * as SS from "src/shared/components/Disclaimer";

import DateTimeRemoveButton from "../DateTimeRemoveButton";
import * as S from "../styled";
import TourDate from "../TourDate";
import TourTime from "../TourTime";
import { ChooseDateTimeContainer, DateTimeAddButton } from "./styled";

const DateTimeSelector = ({ datetimes, onChange }) => {
  const HEADER_TEXT = "DATE AND TIME";
  const newDateTime = [{ date: null, time: null, key: uuid.v4() }];
  const [datetimeList, setDatetimeList] = useState(datetimes);
  const handleAddDatetime = () =>
    setDatetimeList(datetimeList.concat(newDateTime));
  const setChange = () => {
    onChange(datetimeList, { target: { name: "datetimes" } });
  };
  const handleUpdateDatetime = (event, selector, field) => {
    const updatedDatetimeList = datetimeList.slice();
    updatedDatetimeList.find(el => el === selector)[field] = event.value;
    setDatetimeList(updatedDatetimeList);
    setChange();
  };
  const handleRemoveDatetime = removedDT => {
    const datetimeListWithoutSelector = datetimeList.filter(
      datetime => datetime !== removedDT
    );
    setDatetimeList(datetimeListWithoutSelector);
    setChange();
  };

  return (
    <S.RequestFormSectionContainer>
      <S.RequestFormSectionHeader>
        {HEADER_TEXT}
        <SS.Disclaimer>(Optional)</SS.Disclaimer>
      </S.RequestFormSectionHeader>
      <S.RequestFormSectionText>
        Add your available times in order of preference. The agent will contact
        you soon to confirm.
      </S.RequestFormSectionText>
      {datetimeList.map((datetime, index) => (
        <ChooseDateTimeContainer key={datetime.key}>
          <TourDate
            datetime={datetime}
            onUpdateDatetime={handleUpdateDatetime}
          />
          <TourTime
            datetime={datetime}
            onUpdateDatetime={handleUpdateDatetime}
          />
          {datetimeList.length - 1 !== index ? (
            <DateTimeRemoveButton
              datetime={datetime}
              onRemoveDatetime={handleRemoveDatetime}
            />
          ) : (
            <DateTimeAddButton
              closedLabel="+ Add"
              onClick={handleAddDatetime}
              openLabel=""
            />
          )}
        </ChooseDateTimeContainer>
      ))}
      <S.RequestFormBreak />
    </S.RequestFormSectionContainer>
  );
};

DateTimeSelector.propTypes = {
  datetimes: arrayOf(shape({ key: string, date: string, time: string }))
    .isRequired,
  onChange: func.isRequired
};

export default DateTimeSelector;
